import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_toggle = _resolveComponent("ion-toggle")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_select_option = _resolveComponent("ion-select-option")!
  const _component_ion_select = _resolveComponent("ion-select")!
  const _component_ion_list = _resolveComponent("ion-list")!

  return (_openBlock(), _createBlock(_component_ion_list, {
    lines: "full",
    class: "inline-list"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_ion_item, null, {
        default: _withCtx(() => [
          _createVNode(_component_ion_toggle, {
            "aria-label": "Виден другим",
            checked: _ctx.privacy.discoverable,
            onIonChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.update('discoverable', $event.detail.checked)))
          }, {
            default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
              _createTextVNode(" Виден другим ", -1)
            ]))]),
            _: 1
          }, 8, ["checked"])
        ]),
        _: 1
      }),
      _createVNode(_component_ion_item, null, {
        default: _withCtx(() => [
          _createVNode(_component_ion_select, {
            label: "Личные сообщения",
            "label-placement": "stacked",
            value: _ctx.privacy.dmPolicy,
            interface: "popover",
            onIonChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.update('dmPolicy', $event.detail.value)))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_select_option, { value: "NOBODY" }, {
                default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                  _createTextVNode("Нельзя писать", -1)
                ]))]),
                _: 1
              }),
              _createVNode(_component_ion_select_option, { value: "REQUESTS" }, {
                default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                  _createTextVNode("Только по запросу", -1)
                ]))]),
                _: 1
              }),
              _createVNode(_component_ion_select_option, { value: "EVERYONE" }, {
                default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                  _createTextVNode("Можно писать всем", -1)
                ]))]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["value"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}